
import { createApp, nextTick } from 'vue'
import App from '@/App.vue'
import router from '@/js/routes.js'
import store from '@/js/store.js'
import { setAuthToken, resetAuthToken } from '@/js/configs/headers.js'
import commonGlobal from '@/js/common-globals.js'; 
import { createI18n } from 'vue-i18n'
import 'css-tooltip/dist/css-tooltip.css'; 
import mitt from 'mitt'
import { Field, Form, ErrorMessage, defineRule, configure } from 'vee-validate';
import * as rules from '@vee-validate/rules';
import { localize } from '@vee-validate/i18n';
import IntercomPlugin from './js/intercom';
import Notifications from '@kyvg/vue3-notification';
import ImportStatusWidget from '@/js/ordercircle/brands/products/ImportStatusWidget.vue';
import Bugsnag from '@bugsnag/js'
import BugsnagPluginVue from '@bugsnag/plugin-vue'

Bugsnag.start({
  apiKey: import.meta.env.VITE_BUGSNAG_API_KEY,
  releaseStage: import.meta.env.VITE_APP_ENV || 'production',
  enabledReleaseStages: ['production', 'staging', 'local'], // Only report in these stages
  plugins: [new BugsnagPluginVue()]
})

const bugsnagVue = Bugsnag.getPlugin('vue')
// Promise.finally() was added to JavaScript in ES2018 (ES9), so older browsers or environments don't have it.
if (!Promise.prototype.finally) {
  Promise.prototype.finally = function(onFinally) {
    return this.then(
      (value) => Promise.resolve(onFinally()).then(() => value),
      (reason) => Promise.resolve(onFinally()).then(() => { throw reason; })
    );
  };
}

// Use import.meta.glob to load all JSON files dynamically
const modules = import.meta.glob('@/js/ordercircle/brands/lang/*.json', { eager: true })
const messages = {}
window.KTMenu = KTMenu;




// Restore token from localStorage to Axios headers
const savedToken = localStorage.getItem("access-token");
if (savedToken) {
  setAuthToken(savedToken);
} else {
  resetAuthToken();
}


for (const path in modules) {
  // Extract the language code from filename e.g. en.json -> en
  const lang = path.split('/').pop().split('.')[0]
  messages[lang] = modules[path].default
}

const i18n = createI18n({
  legacy: false,
  locale: 'en',
  fallbackLocale: 'en',
  messages,
})

// Ensure KTAppSettings is available globally
window.KTAppSettings = window.KTAppSettings || {};

const app = createApp(App)
// For debuging purposes
app.config.devtools = true; 
app.config.errorHandler = (err, vm, info) => {
  console.error('Vue Error:', err, 'Info:', info, 'Component:', vm);
};

const eventBus = mitt();
app.config.globalProperties.eventBus = eventBus; // Make eventBus globally available

// app.directive('autofocus', {
//   mounted(el) {
//     el.focus()
//   }
// })

app.mixin(commonGlobal);
app.use(store)  
app.use(router)
app.use(i18n)
app.use(IntercomPlugin);
app.use(Notifications);
app.use(bugsnagVue);
import axios from 'axios';
// Setup axios interceptors
axios.interceptors.response.use(
  response => {
    return response;
  },
  error => {
     console.log('Axios response error:', error);
    //  if(error.response) {
      //  Bugsnag.notify(JSON.stringify(error));
      Bugsnag.notify(error);
    //  }
  if (error.response && (error.response.status === 401 || error.response.status === 419)) {
    store.commit('SHOW_LOADER',true);
    store.dispatch('reset').then(response => {
      store.commit('SHOW_LOADER',false);
      // router.push("/");
      window.location.href = "/";
    })
  }
    return Promise.reject(error);
  }
);

app.mount('#app')

// Mount ImportStatusWidget as floating widget
let widgetApp = null;
let widgetInstance = null;

// Function to mount the widget
window.ocEnsureProductsImportWidgetMounted = function() {
    if (widgetInstance) {
        return; // Already mounted
    }
    
    try {
        // Create container for widget if it doesn't exist
        let container = document.getElementById('oc-import-widget-container');
        if (!container) {
            container = document.createElement('div');
            container.id = 'oc-import-widget-container';
            document.body.appendChild(container);
        }
        
        // Create new Vue app for widget
        widgetApp = createApp(ImportStatusWidget);
        widgetApp.use(store);
        widgetApp.use(router);
        widgetApp.use(i18n);
        
        widgetInstance = widgetApp.mount(container);
    } catch (error) {
        console.error('Failed to mount ImportStatusWidget:', error);
    }
};

// Function to trigger widget re-check
window.ocProductsImportWidgetBump = function() {
    if (widgetInstance && widgetInstance.lsTick !== undefined) {
        widgetInstance.lsTick = Date.now();
    }
};

// Function to unmount widget
window.ocUnmountProductsImportWidget = function() {
    if (widgetApp) {
        try {
            widgetApp.unmount();
            widgetApp = null;
            widgetInstance = null;
        } catch (e) {}
    }
    
    // Remove container
    const container = document.getElementById('oc-import-widget-container');
    if (container) {
        container.remove();
    }
};

// Register components globally
app.component('Field', Field);
app.component('Form', Form);
app.component('ErrorMessage', ErrorMessage);

// For modal backdrop cleanup
$(document).on('hidden.bs.modal', function () {
  nextTick(() => {
    $(".modal-backdrop").remove(); 
    $("body").removeClass("modal-open"); 
    })
});

//  After Vue mounted, initialize Metronic layout
nextTick(() => {
  if (window.KTApp) {
    window.KTApp.init(); // Initialize Metronic App
  }
  if (window.KTLayout) {
    window.KTLayout.init(); // Initialize Metronic Layout
  }
  if (window.KTMenu) {
    window.KTMenu.init(); // Initialize Metronic Menus
  }
});